<template lang="pug">
el-container(style="height: 100vh" direction="vertical")
  publicHeader
  
  el-main
    .error404
      h1 404
      h2 Page Not Found
      p The destination page currently does not exist.<br>Please return to the login screen.
      
      p.go
        router-link(:to="{name:'sign_in'}")
          i.el-icon-back {{ $t('sign_in.back_signin') }}

  publicFooter

</template>

<script>
import Header from '../public/Header.vue'
import Footer from '../public/Footer.vue'

export default {
  data() {
    return {

    }
  },
  title() {
    return '404'
  },
  components: {
    'publicHeader': Header,
    'publicFooter': Footer
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.error404 {
  width: 500px;
  margin: 0 auto;
  text-align: center;

  h1 {
    font-size: 72px;
  }

  p.go {
    margin-top: 50px;
    font-size: 14px;
  }
}
</style>

